import { styled } from '../../utils/styled'
import Grid from '../Grid'
import Typography from '../Typography'

export const HEADER_HEIGHT_PX = 64

const IMAGE_MAX_WIDTH = '90vw'
const IMAGE_MAX_HEIGHT = `calc(85vh - ${HEADER_HEIGHT_PX}px)`

export const StyledHeader = styled(Grid)(({ theme }) => ({
  height: HEADER_HEIGHT_PX,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: `0 ${theme.spacing(3)}`,
  backgroundColor: theme.tokens.background.main.default,
  borderBottom: `1px solid ${theme.tokens.border.main.tonal}`
}))

export const StyledFilename = styled(Typography)(() => ({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}))

export const StyledActions = styled(Grid)(({ theme }) => ({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}))

export const StyledImageArea = styled(Grid)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  backgroundColor: theme.tokens.background.tonal.soft.default
}))

export const StyledImage = styled('img')(() => ({
  maxWidth: IMAGE_MAX_WIDTH,
  maxHeight: IMAGE_MAX_HEIGHT,
  objectFit: 'contain',
  display: 'block',
  cursor: 'default',
  userSelect: 'none'
}))
